import amazon from "assets/pictures/Amazon Pay.png";
import logo from "assets/pictures/header-logo.png";
import visacard from "assets/images/visa.avif";
import mastercard from "assets/images/master.avif";
import maestrocard from "assets/images/Maestro.avif";
import amexcard from "assets/images/Amex.avif";
import amazoncard from "assets/images/Amazon-Pay.avif";
import paytmcard from "assets/images/paytm.avif";
import upicard from "assets/images/upi.avif";
import { Link, useParams, useNavigate, useSearchParams } from "react-router-dom";

import { Fragment, useState } from "react";
import { API_ENDPOINTS, request } from "utilities";
import notification from "utilities/notification";
import { useCart } from "hooks";
import { ProductCard, ProductQuery } from "components/products";
import { useDispatch, useSelector } from "react-redux";

function Footer({ category }) {
  const { items } = useCart(); // Assuming useCart returns { items: [] }
  const cartItemCount = items?.length || 0; // Fallback to 0 if items is undefined
  const navigate = useNavigate();
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  let [searchParams] = useSearchParams();

  const [email, setEmail] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    request.post(API_ENDPOINTS.NEWSLETTER, { email }).then((response) => {
      if (response?.success) {
        notification("success", response?.message);
        setEmail("");
      }
    });
  };
  const handleNavigate = (e, key, value) => {
    const Obj = {};
    for (const [key, value] of searchParams) {
      if (key === "price") {
        Object.assign(Obj, { price_min: value[0] });
        Object.assign(Obj, { price_max: value[1] });
      } else {
        Object.assign(Obj, { [key]: value });
      }
    }
    if (key === "price") {
      Object.assign(Obj, { price_min: value[0] });

      Object.assign(Obj, { price_max: value[1] });
    } else {
      Object.assign(Obj, { [key]: value });
    }
    // Object.assign(Obj, { [key]: value })
    const query = new URLSearchParams(Obj).toString();

    window.location.href = `/products?${query}`;
  };

  const handleSearchClick = (e) => {
    e.preventDefault(); // Prevent <Link> navigation
    setShowSearch(true);
  };

  const closeSearch = () => {
    setShowSearch(false);
  };

  const performSearch = () => {
    if (searchQuery.trim()) {
      const query = new URLSearchParams({
        search: searchQuery.trim(),
      }).toString();
      navigate(`/products?${query}`);
      setShowSearch(false);
      setSearchQuery("");
    }
  };

  const { id } = useParams();
  const { data: product } = ProductQuery(id);
  const { data: carts } = useSelector((state) => state.cart);
  const currentItem = carts.find((item) => item?.id === product?.id);
  const { data: products } = ProductQuery();
  const { data } = ProductQuery();

  return (
    <Fragment>
      <div className="container-fluid footsection ">
        <div className="main-footer-section py-4">
          <div className="row  pt-5 pb-5 ">
            <div className="col-lg-4 col-md-4">
              <div className="footer-logo-section">
                <img src={logo} alt="" />
                <p>
                  Luxeoutlet has redefined conventional shopping experience with
                  a brand portfolio that represents the pinnacle of the
                  craftsmanship and unsurpassed quality further reinforcing its
                  position as India's most desirable destination for world class
                  brands.{" "}
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="footdata">
                <ul>
                  <li>
                    <div className="foothead">Quick Links</div>
                  </li>
                  <Link to="/who-we-are" target="_blank">
                    <li>Who we are ?</li>
                  </Link>

                  <Link to="/terms-condition" target="_blank">
                    <li>Terms & Conditions</li>
                  </Link>
                  <Link to="/privacy-policy" target="_blank">
                    <li>We respect your privacy </li>
                  </Link>
                  <Link to="/Contact" target="_blank">
                    <li>Contact Us</li>
                  </Link>
                  <Link to="/Shipping" target="_blank">
                    <li>Shipping & Returns</li>
                  </Link>
                  {/* <Link to="#"><li>Authentication Certificate </li></Link> */}
                  <Link to="/faqs" target="_blank">
                    <li>FAQs</li>
                  </Link>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="footdata">
                <ul>
                  <li>
                    <div className="foothead mb-3">SHOP BY</div>
                  </li>
                  <div className="scroll-div">
                    {Object.keys(category).map((name, idx) => (
                      <li
                        className=" cat-filt category"
                        style={{ cursor: "pointer" }}
                        key={idx}
                      >
                        <a
                          onClick={(e) =>
                            handleNavigate(e, "category", category[name])
                          }
                        >
                          {name}
                        </a>
                      </li>
                    ))}
                  </div>
                </ul>
              </div>
            </div>
          </div>

          <div className="container">
            <h6 className="text-center">CHECKOUT SECURELY WITH</h6>
            <div className="d-flex flex-wrap justify-content-center my-3 gap-3 img-card">
              <img src={visacard} alt="" />
              <img src={mastercard} alt="" />
              <img src={maestrocard} alt="" />
              <img src={amexcard} alt="" />
              <img src={amazoncard} alt="" />
              <img src={paytmcard} alt="" />
              <img src={upicard} alt="" />
            </div>
            <h6 className="text-center mt-4">
              Copyright © 2023 Luxeoutlet. All right reserved
            </h6>
          </div>
        </div>
      </div>

      <nav className="bottom-nav">
        <ul className="bottom-nav-list">
          <li className="bottom-nav-item">
            <Link to="/" className="bottom-nav-link">
              <i className="fas fa-home bottom-nav-icon"></i>
              <span>Home</span>
            </Link>
          </li>
          <li className="bottom-nav-item">
            <a href="#" className="bottom-nav-link" onClick={handleSearchClick}>
              <i className="fas fa-search bottom-nav-icon"></i>
              <span>Search</span>
            </a>
          </li>
          <li className="bottom-nav-item">
            <Link to="/cart" className="bottom-nav-link">
              <i className="fas fa-shopping-cart bottom-nav-icon"></i>
              {cartItemCount > 0 && (
                <span className="cart-badge">{cartItemCount}</span>
              )}
              <span>Cart</span>
            </Link>
          </li>
          <li className="bottom-nav-item">
            <Link to="/profile" className="bottom-nav-link">
              <i className="fas fa-user bottom-nav-icon"></i>
              <span>Profile</span>
            </Link>
          </li>
        </ul>
      </nav>

      {showSearch && (
  <div className="bottom-sheet">
  <div className="sheet-header">
    <div className="input-container">
      <button className="arrow-btn" onClick={closeSearch}>
        ←
      </button>
      <input
        type="text"
        className="form-control"
        placeholder="Find you needed..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            performSearch();
          }
        }}
        autoFocus
      />
    </div>
  </div>
  <div className="container details-product mt-5 Related-product-section">
    <h3 style={{ fontSize: "24px" }}>Related Products</h3>
    <Link className="text-dark text-decoration-none" to="/products">
      View more
    </Link>
  </div>
  <div className="container">
    <div className="row text-center mt-2 mb-5">
      {products.length > 0 ? (
        <Fragment>
          {products.map((product, idx) => {
            if (idx < 4) {
              return (
                <Fragment key={idx}>
                  <ProductCard product={product} />
                </Fragment>
              );
            }
          })}
        </Fragment>
      ) : (
        <div className="alert alert-info">No product found</div>
      )}
    </div>
  </div>
  <button className="btn btn-primary mt-2" onClick={performSearch}>
    Search
  </button>
</div>
      )}
    </Fragment>
  );
}

export default Footer;
